module.exports = "table {\r\n    width: 100%;\r\n  }"